"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEditorStyle = (wrapperId) => {
    (0, react_1.useEffect)(() => {
        const styleId = "tinymce-remove-border-styles";
        if (document.getElementById(styleId))
            return;
        const style = document.createElement("style");
        style.id = styleId;
        style.innerHTML = `
      /* scope to this wrapper so other editors/pages are unaffected */
      #${wrapperId} .tox.tox-tinymce,
      #${wrapperId} .tox.tox-tinymce * {
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: transparent !important;
      }

      #${wrapperId} .tox .tox-editor-container,
      #${wrapperId} .tox .tox-editor-header,
      #${wrapperId} .tox .tox-toolbar,
      #${wrapperId} .tox .tox-toolbar__primary,
      #${wrapperId} .tox .tox-statusbar,
      #${wrapperId} .tox .tox-edit-area {
        border: none !important;
        box-shadow: none !important;
      }

      /* If an iframe is present, ensure it has no border */
      #${wrapperId} .tox .tox-edit-area iframe {
        border: none !important;
        box-shadow: none !important;
      }

      /* remove inner editor focus outlines */
      #${wrapperId} .mce-content-body:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    `;
        document.head.appendChild(style);
        return () => {
            const el = document.getElementById(styleId);
            if (el)
                el.remove();
        };
    }, [wrapperId]);
};
exports.default = useEditorStyle;
